import { Stack } from '@chakra-ui/react'
import { useCallback, useEffect } from 'react'
import { Outlet, useLoaderData, useParams } from 'react-router-dom'

import { idAndTypeToRfId } from '@app/pages/strategies/components/nodes/helpers'
import { useDrawerContext } from '@app/pages/strategies/drawerContext'
import Drawer from '@app/shared/drawer/drawer'
import { useStore } from '@app/store'

const StrategyDrawer = () => {
  const { nodeId } = useParams()
  const { nodeType } = useLoaderData() as { nodeType: string }
  const { onDrawerClose } = useDrawerContext()
  const getNodeById = useStore.use.getNodeById()
  const node = getNodeById(idAndTypeToRfId(nodeId, nodeType))

  const onSuccessHandler = useCallback(() => {
    onDrawerClose()
  }, [onDrawerClose])

  const nodeExists = !!node

  useEffect(() => {
    if (!nodeExists && nodeType !== 'comment') {
      onSuccessHandler()
    }
  }, [nodeExists, nodeType, onSuccessHandler])

  // onOpenChange is only a requirement for the escape key handling, we should aim to remove it
  return (
    <Drawer onOpenChange={onDrawerClose} open>
      <Stack as="section" gap={0} overflow="auto" h="100%" id="lazyload-container">
        <Outlet />
      </Stack>
    </Drawer>
  )
}

export default StrategyDrawer
